import { post,get,formPost } from "@/utils/request";

export const getAllShopPage = (p) => post('/shop/getAllShopPage', p)
export const getMyShopPage = (p) => post('/shop/getMyShopPage', p)
export const saveShop = (p) => post('/shop/saveShop', p)
export const deleteShop = (p) => post('/shop/deleteShop', p)
export const getShopOptions = () => post('/shop/getShopOptions', {})
export const getMyShopOptions = (p) => post('/shop/getMyShopOptions', p)
export const getShopAuthorUrl = (p) => get('/shop/getShopAuthorizationUrl', p)
export const spCommonCallBack = (p) => post('/api/externalCallBalk/spCommonCallBack', p)
export const tkShopCallBack = (p) => formPost('/api/externalCallBalk/tkShopCallBack', p)